/**
 * 分享模块
 */

// @ts-ignore
import $store from '@/sheep/store';

// @ts-ignore
import $router from '@/sheep/router';

// @ts-ignore
import $platform from '@/sheep/platform';

// @ts-ignore
import $url from '@/sheep/url';

// @ts-ignore
// import BrokerageApi from '@/sheep/api/trade/brokerage';

import { SharePageEnum } from '@/sheep/helper/constants';

// #ifdef H5
// @ts-ignore
import $wxsdk from '@/sheep/libs/sdk-h5-weixin';
// #endif

/** 平台映射 */
const platformMap = ['H5', 'WechatOfficialAccount', 'WechatMiniProgram', 'App'];

/** 分享方式映射 */
const fromMap = ['forward', 'poster', 'link'];

/** 分享参数 */
interface ShareScene {
  title?: string;
  desc?: string;
  image?: string;
  params?: Record<string, any>;
}

/** 海报参数 */
interface PosterConfig {
  type?: string;
}

/** 分享信息 */
interface ShareInfo {
  title: string;
  desc: string;
  image: string;
  path: string;
  link: string;
  query: string;
  poster: PosterConfig;
  forward: Record<string, any>;
}

/**
 * 设置分享信息参数
 * @param scene 分享场景
 * @param poster 海报配置
 */
const getShareInfo = (scene: ShareScene = {}, poster: PosterConfig = { type: 'user' }): ShareInfo => {
  const shareInfo: ShareInfo = {
    title: '',
    desc: '',
    image: '',
    path: '',
    link: '',
    query: '',
    poster,
    forward: {},
  };

  shareInfo.title = scene.title || '';
  shareInfo.image = $url.cdn(scene.image || '');
  shareInfo.desc = scene.desc || '';

  const app = $store('app');
  const shareConfig = app.platform.share;

  // 自动拼接分享用户参数
  const query = buildSpmQuery(scene.params || {});
  shareInfo.query = query;

  // 配置分享链接地址
  shareInfo.link = buildSpmLink(query, shareConfig.linkAddress);
  // 配置页面地址带参数
  shareInfo.path = buildSpmPath();

  // 配置页面转发参数
  if (shareConfig.methods.includes('forward')) {
    shareInfo.forward.path = buildSpmPath(query);
  }

  return shareInfo;
};

/**
 * 构造 spm 分享参数
 * @param params 分享参数
 * @returns 分享串 `spm=${shareId}.${page}.${query}.${platform}.${from}`
 */
const buildSpmQuery = (params: Record<string, any>): string => {
  const user = $store('user');
  let shareId = '0';

  if (typeof params.shareId === 'undefined') {
    if (user.isLogin) {
      shareId = user.userInfo.id;
    }
  } else {
    shareId = params.shareId;
  }

  let page = SharePageEnum.HOME.value;
  if (typeof params.page !== 'undefined') {
    page = params.page;
  }

  let query = '0';
  if (typeof params.query !== 'undefined') {
    query = params.query;
  }

  const platform = String(platformMap.indexOf($platform.name) + 1);
  let from = '1';
  if (typeof params.from !== 'undefined') {
    from = String(platformMap.indexOf(params.from) + 1);
  }

  return `spm=${shareId}.${page}.${query}.${platform}.${from}`;
};

/**
 * 构造页面分享参数
 * @param query 查询参数
 */
const buildSpmPath = (query?: string): string => {
  return typeof query === 'undefined' ? 'pages/index/index' : `pages/index/index?${query}`;
};

/**
 * 构造分享链接
 * @param query 查询参数
 * @param linkAddress 链接地址
 */
const buildSpmLink = (query: string, linkAddress = ''): string => {
  return `${linkAddress}?${query}`;
};

/**
 * 解析Spm
 * @param spm spm字符串
 */
const decryptSpm = (spm: string) => {
  const user = $store('user');
  const shareParamsArray = spm.split('.');

  const shareParams: any = {
    spm,
    shareId: 0,
    page: '',
    query: {},
    platform: '',
    from: '',
  };

  shareParams.shareId = shareParamsArray[0];

  switch (shareParamsArray[1]) {
    case SharePageEnum.HOME.value:
      shareParams.page = SharePageEnum.HOME.page;
      break;
    case SharePageEnum.GOODS.value:
      shareParams.page = SharePageEnum.GOODS.page;
      shareParams.query = { id: shareParamsArray[2] };
      break;
    case SharePageEnum.GROUPON.value:
      shareParams.page = SharePageEnum.GROUPON.page;
      shareParams.query = { id: shareParamsArray[2] };
      break;
    case SharePageEnum.SECKILL.value:
      shareParams.page = SharePageEnum.SECKILL.page;
      shareParams.query = { id: shareParamsArray[2] };
      break;
    case SharePageEnum.GROUPON_DETAIL.value:
      shareParams.page = SharePageEnum.GROUPON_DETAIL.page;
      shareParams.query = { id: shareParamsArray[2] };
      break;
    case SharePageEnum.POINT.value:
      shareParams.page = SharePageEnum.POINT.page;
      shareParams.query = { id: shareParamsArray[2] };
      break;
    case SharePageEnum.WISH_DETAIL.value:
      shareParams.page = SharePageEnum.WISH_DETAIL.page;
      shareParams.query = { id: shareParamsArray[2] };
      break;
    case SharePageEnum.FEED_DETAIL.value:
      shareParams.page = SharePageEnum.FEED_DETAIL.page;
      shareParams.query = { id: shareParamsArray[2] };
      break;
  }

  shareParams.platform = platformMap[parseInt(shareParamsArray[3]) - 1];
  shareParams.from = fromMap[parseInt(shareParamsArray[4]) - 1];

  if (shareParams.shareId !== '0') {
    uni.setStorageSync('shareId', shareParams.shareId);
    if (user.isLogin) {
      bindBrokerageUser(shareParams.shareId);
    }
  }

  if (shareParams.page !== SharePageEnum.HOME.page) {
    $router.go(shareParams.page, shareParams.query);
  }

  return shareParams;
};

/**
 * 绑定推广员
 * @param val 推广员ID
 */
const bindBrokerageUser = async (val?: string) => {
  try {
    const shareId = val || uni.getStorageSync('shareId');
    if (!shareId) return;

    const { data } = null // await BrokerageApi.bindBrokerageUser({ bindUserId: shareId });
    if (data) {
      uni.removeStorageSync('shareId');
    }
  } catch (e) {
    console.error(e);
  }
};

/**
 * 更新公众号分享sdk
 * @param shareInfo 分享信息
 */
const updateShareInfo = (shareInfo: ShareInfo) => {
  // #ifdef H5
  if ($platform.name === 'WechatOfficialAccount') {
    $wxsdk.updateShareInfo(shareInfo);
  }
  // #endif
};

export default {
  getShareInfo,
  updateShareInfo,
  decryptSpm,
  bindBrokerageUser,
};
